// extracted by mini-css-extract-plugin
module.exports = {"android":"menu-template-module--android--3tsr3"};